// utils/analytics.js

/**
 * Sends a custom event to Google Analytics 4
 * @param {string} eventName - Name of the event (use underscores, e.g., 'quiz_completed')
 * @param {Object} params - Key-value pairs of parameters you want to track
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else {
    // Optional: Log to console in development environment so you can debug
    if (process.env.NODE_ENV === 'development') {
      console.log(`[GA4 Mock Event] ${eventName}:`, params);
    }
  }
};

export const EVENT_CLICK = "event_click";
export const EVENT_NAME = "name";

export const EVENT_VALUE_REGISTER = "register";
export const EVENT_VALUE_EXPLORE_CURRICULUM = "explore_curriculum";
export const EVENT_VALUE_LOGIN = "login";
export const EVENT_SIGNUP_COMPLETED = "signup_completed";
export const EVENT_CHILD_ADDED = "child_added";